import axiosInstance from "../utils/axiosInstance";
import { API_ENDPOINTS } from "../constants/config";

// Vehicle Route API Service
export const vehicleRouteService = {
  // Get all vehicle routes for a school
  getVehicleRoutes: async (schoolId) => {
    try {
      const response = await axiosInstance.get(API_ENDPOINTS.vehicleRoutesBySchool(schoolId));
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get vehicle route by ID
  getVehicleRouteById: async (routeId) => {
    try {
      const response = await axiosInstance.get(API_ENDPOINTS.vehicleRoute(routeId));
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Create new vehicle route
  createVehicleRoute: async (routeData) => {
    try {
      const response = await axiosInstance.post(API_ENDPOINTS.vehicleRoutes, routeData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Update vehicle route
  updateVehicleRoute: async (routeId, routeData) => {
    try {
      const response = await axiosInstance.put(API_ENDPOINTS.vehicleRoute(routeId), routeData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Delete vehicle route
  deleteVehicleRoute: async (routeId) => {
    try {
      const response = await axiosInstance.delete(API_ENDPOINTS.vehicleRoute(routeId));
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Add shift to vehicle route
  addShift: async (routeId, shiftData) => {
    try {
      const response = await axiosInstance.post(API_ENDPOINTS.vehicleRouteShifts(routeId), shiftData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Update shift
  updateShift: async (routeId, shiftId, shiftData) => {
    try {
      const response = await axiosInstance.put(API_ENDPOINTS.vehicleRouteShift(routeId, shiftId), shiftData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Delete shift
  deleteShift: async (routeId, shiftId) => {
    try {
      const response = await axiosInstance.delete(API_ENDPOINTS.vehicleRouteShift(routeId, shiftId));
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Add stop to shift
  addStop: async (routeId, shiftId, stopData) => {
    try {
      const response = await axiosInstance.post(API_ENDPOINTS.vehicleRouteShiftStops(routeId, shiftId), stopData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Update stop
  updateStop: async (routeId, shiftId, stopId, stopData) => {
    try {
      const response = await axiosInstance.put(API_ENDPOINTS.vehicleRouteShiftStop(routeId, shiftId, stopId), stopData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Delete stop
  deleteStop: async (routeId, shiftId, stopId) => {
    try {
      const response = await axiosInstance.delete(API_ENDPOINTS.vehicleRouteShiftStop(routeId, shiftId, stopId));
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Update stop order (drag and drop)
  updateStopOrder: async (routeId, shiftId, stopIds) => {
    try {
      // Ensure IDs are strings and remove any extra characters
      const cleanRouteId = String(routeId).trim();
      const cleanShiftId = String(shiftId).trim().split(':')[0]; // Remove any colon suffixes
      
      const response = await axiosInstance.put(
        API_ENDPOINTS.vehicleRouteStopsOrder(cleanRouteId, cleanShiftId), 
        { stopIds }
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get available students for assignment
  getAvailableStudents: async (schoolId) => {
    try {
      const response = await axiosInstance.get(API_ENDPOINTS.vehicleRoutesSchoolStudents(schoolId));
      return response.data;
    } catch (error) {
      throw error;
    }
  }
};

// Vehicle API Service
export const vehicleService = {
  // Get all vehicles for a school
  getVehicles: async (schoolId) => {
    try {
      const response = await axiosInstance.get(API_ENDPOINTS.vehiclesBySchool(schoolId));
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get vehicle by ID
  getVehicleById: async (vehicleId) => {
    try {
      const response = await axiosInstance.get(API_ENDPOINTS.vehicle(vehicleId));
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Create new vehicle
  createVehicle: async (vehicleData) => {
    try {
      const response = await axiosInstance.post(API_ENDPOINTS.vehicles, vehicleData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Update vehicle
  updateVehicle: async (vehicleId, vehicleData) => {
    try {
      const response = await axiosInstance.put(API_ENDPOINTS.vehicle(vehicleId), vehicleData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Delete vehicle
  deleteVehicle: async (vehicleId) => {
    try {
      const response = await axiosInstance.delete(API_ENDPOINTS.vehicle(vehicleId));
      return response.data;
    } catch (error) {
      throw error;
    }
  }
}; 